module.exports = __webpack_public_path__ + "static/assets/127373191db953ce5e27630fda2ca80c.png";